export default Object.freeze({
  // DEV
  // API_URL: 'http://192.168.1.222/api/',
  // IMAGE_PATH: 'http://192.168.1.222/images/',
  API_URL: 'https://quinielacuauhtemoc.com/public/api/',
  IMAGE_PATH: 'https://quinielacuauhtemoc.com/public/images',
})
